module.exports = __webpack_public_path__ + "static/media/oasis.1ca9abdd.png";